<div class="layoutBlock">
    <div class="detailpageCenter" *ngFor="let category of categories;" [style]="{'width': '100%'}">
        <p-panel header="{{'rm.erp.jobapplication.' + category.id + '.title' | hisUi }}" [toggleable]="true">

            <span *ngFor="let field of category.fields">
                <erp-jobapplication-field [field]="field" [jobApplication]="jobApplication.application"
                    [readonly]="false" (valueChange)="onChange($event)">
                </erp-jobapplication-field>

                <ng-container *ngIf="category.id === 'cat.documents' && field.maxFileSize && field.maxFiles">
                    <his-plam>
                        <p-autoComplete #content hisDdKey="rm.erp.jobapplication.JobApplication.document.category"
                            styleClass="autocompleteWidth100" [(ngModel)]="documentCategory"
                            [suggestions]="filteredDocumentCategoryValues" [dropdown]="true" [size]="42" [minLength]="1"
                            field="longtext" (completeMethod)="relevantDocumentCategoryValues()" [forceSelection]="true"
                            (ngModelChange)="toggleDocumentUploadButton($event, fileUpload)">
                        </p-autoComplete>
                    </his-plam>

                    <div class="clearAndSpace"></div>

                    <p-fileUpload #fileUpload [disabled]="toggleUploadButtonDisabled" mode="advanced"
                        chooseLabel="{{'rm.erp.jobapplication.Jobapplication.upload.chooseFile' | hisUi}}" chooseIcon=""
                        [customUpload]="true" [auto]="true" (uploadHandler)="customUploadHandler($event, fileUpload)"
                        styleClass="inputWidth100" [fileLimit]="field.maxFiles"
                        invalidFileLimitMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileLimit.summary' | hisUi}} {0}"
                        invalidFileLimitMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileLimit.detail' | hisUi}} {0}"
                        [maxFileSize]="field.maxFileSize"
                        invalidFileSizeMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileSize.summary' | hisUi}} {0}"
                        invalidFileSizeMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileSize.detail' | hisUi}} {0}"
                        accept="{{field.allowedFileExtensions.join(', ')}}"
                        invalidFileTypeMessageSummary="{{'rm.erp.common.documents.uploadFile.invalidFileType.summary' | hisUi}} {0}"
                        invalidFileTypeMessageDetail="{{'rm.erp.common.documents.uploadFile.invalidFileType.detail' | hisUi}} {0}">

                        <ng-template pTemplate="toolbar">
                            <button (click)="fileUploadHint.toggle($event)" hisImage="information" class="icon"
                                title="Informationen"></button>
                            <p-overlayPanel #fileUploadHint [showCloseIcon]="true" [dismissable]="true">
                                <ng-template pTemplate>
                                    <p
                                        [innerHTML]="getDocumentUploadHelptext(field.maxFiles, field.maxFileSize, field.allowedFileExtensions.join(', '))">
                                    </p>
                                </ng-template>
                            </p-overlayPanel>
                        </ng-template>
                        <ng-template pTemplate="content" let-i="index">
                            <div>
                                <span *ngIf="jobApplication.documents.length === 0">
                                    {{'rm.erp.common.documents.uploadFile.noFileSelected' | hisUi}}
                                </span>
                                <span *ngIf="jobApplication.documents.length > 0">
                                    <p-table [value]="jobApplication.documents" [paginator]="false" [responsive]="true">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'rm.erp.common.documents.upload.filecategory' | hisUi}}</th>
                                                <th>{{'rm.erp.common.documents.upload.filename' | hisUi}}</th>
                                                <th>{{'rm.erp.common.documents.upload.filesize' | hisUi}}</th>
                                                <th>{{'rm.erp.common.documents.upload.actions' | hisUi}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-index="rowIndex" let-document>
                                            <tr>
                                                <td>{{ document.documentCategory?.longtext }}</td>
                                                <td>{{ document.filename }}</td>
                                                <td>{{ document.filesize }}</td>
                                                <td>
                                                    <button (click)="removeFile($event, index, fileUpload)"
                                                        hisImage="delete" class="icon"
                                                        title="{{'rm.erp.common.documents.upload.remove.tooltip' | hisUi}}"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </span>
                            </div>
                        </ng-template>
                        <div class="clearAndSpace"></div>
                        <ng-template pTemplate="file"></ng-template>
                    </p-fileUpload>
                </ng-container>
            </span>
        </p-panel>
        <div class="clearAndSpace"></div>
    </div>
</div>

<div class="clearAndSpace"></div>

<div>
    <button (click)="validateJobApplication($event)" hisImage="ARROW_RIGHT_FAT"
        class="button_highlighted_dark_green application_arrow_paging arrow_left">
        {{'rm.erp.jobapplication.button.showOverview'| hisUi }}
    </button>
    <button (click)="deleteJobApplication($event)" hisImage="DELETE"
        class="button_highlighted red application_arrow_paging arrow_right">
        {{'rm.erp.jobapplication.button.clear' | hisUi}}
    </button>
</div>
